import instance from "../";

export const getPlaidLinkToken = async (accountID: string) => {
  const { data } = await instance.get<{
    expiration: string;
    link_token: string;
  }>(`/accounts/${accountID}/plaid/link/token`);
  return data;
};

export const getPlaidAuthStatus = async (plaidAcconutID: string) => {
  const { data } = await instance.get<{ verification_status: string }>(
    `/accounts/${plaidAcconutID}/plaid/auth_status`,
  );
  return data;
};

export const getPlaidStripeLinkToken = async () => {
  const { data } = await instance.get<{
    expiration: string;
    link_token: string;
  }>("/plaid/stripe/link/token");
  return data;
};

// These come from successfully linking Plaid Account to Stripe
export interface PostPlaidStripeParams {
  publicToken: string;
  plaidAccountId: string;
}

export const postPlaidStripe = async ({
  publicToken,
  plaidAccountId,
}: PostPlaidStripeParams) => {
  const { data } = await instance.post<{ token: string }>(`/plaid/stripe`, {
    public_token: publicToken,
    account_id: plaidAccountId,
  });
  return data;
};
